import type { ReactNode } from "react";
import type { Transaction } from "../../../types";
import type { TransactionFilters } from "../../../app/views";
import { dateLabel, money, plural } from "../../../lib/finance";
import { rhythm } from "../overview-data";
import { Private } from "../../../components/Privacy";

export default function SpendingRhythm({ expenses, month, today, collapsed, collapseButton, showTransactions }: {
  expenses: Transaction[];
  month: string;
  today: string;
  collapsed: boolean;
  /** The module's collapse toggle, drawn by the caller so every module's matches. */
  collapseButton: ReactNode;
  showTransactions: (filters: TransactionFilters) => void;
}) {
  const spendingRhythm = rhythm(expenses, month, today);
  return (
    <section className={`spending-rhythm overview-module${collapsed ? " is-collapsed" : ""}`} aria-labelledby="spending-rhythm-title">
      <div className="spending-rhythm-heading">
        <h2 id="spending-rhythm-title">Spending rhythm</h2>
        <div className="overview-heading-actions"><span className="expanded-summary">{plural(spendingRhythm.elapsedDays, "day")} elapsed</span><span className="collapsed-summary">{spendingRhythm.spendingDays} spend · {spendingRhythm.zeroDays} zero</span>{collapseButton}</div>
      </div>
      <div className="spending-rhythm-grid">
        <div><span>Spending days</span><strong>{spendingRhythm.spendingDays}</strong></div>
        <div><span>Zero-spend days</span><strong>{spendingRhythm.zeroDays}</strong></div>
        <button disabled={!spendingRhythm.peak} onClick={() => {
          if (spendingRhythm.peak) showTransactions({ date: spendingRhythm.peak[0], type: "Expense" });
        }}><span>Peak outflow</span><strong>{spendingRhythm.peak ? <Private>{money(spendingRhythm.peak[1])}</Private> : "—"}</strong><small>{spendingRhythm.peak ? dateLabel(spendingRhythm.peak[0]) : "No spending"}</small></button>
        <div><span>Daily average</span><strong><Private>{money(spendingRhythm.dailyAverage)}</Private></strong></div>
        <div><span>Active-day average</span><strong><Private>{money(spendingRhythm.activeAverage)}</Private></strong></div>
        <div><span>Current streak</span><strong>{spendingRhythm.streakDays} day{spendingRhythm.streakDays === 1 ? "" : "s"}</strong><small>{spendingRhythm.streakKind === "spending" ? "Spending" : "Zero-spend"}</small></div>
      </div>
    </section>
  );
}
